import { forwardRef } from 'react'
import classnames from 'classnames'

const DateInput = forwardRef(({ error, ...inputProps }, ref) => {
  return (
    <div ref={ref} className={classnames('fieldContainer', { error })}>
      <input {...inputProps} />

      <style jsx>{`
        .fieldContainer {
          width: 100%;

          input {
            width: 100%;
            height: 4.2rem;
            padding: 0 1.9rem;
            border: 0.2rem solid var(--secondary-input-bg);
            border-radius: 2.1rem;
            outline: none;
            transition: border-color 0.2s;
            font-size: 1.6rem;

            &:focus {
              border-color: var(--primary-color);
            }
          }

          &.error {
            input {
              border-color: var(--alert-color);
            }
          }
        }

        @media (max-width: 1024px) {
          .fieldContainer {
            input {
              height: 3.5rem;
              padding: 0 1.4rem;
              border-radius: 3.9rem;
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
})

export default DateInput
